import ContentRenders from "./ContentRenders";

// Helper function to determine MIME type from file extension
const getMimeTypeFromExtension = (filename) => {
  if (!filename) return "image/jpeg"; // default fallback
  
  const extension = filename.toLowerCase().split('.').pop();
  const mimeTypes = {
    'svg': 'image/svg+xml',
    'png': 'image/png',
    'jpg': 'image/jpeg',
    'jpeg': 'image/jpeg',
    'gif': 'image/gif',
    'webp': 'image/webp',
    'bmp': 'image/bmp',
    'ico': 'image/x-icon',
    'tiff': 'image/tiff',
    'tif': 'image/tiff'
  };
  
  return mimeTypes[extension] || "image/jpeg";
};

// Helper function to find filename in content array
const findFilenameInContent = (content) => {
  const textContent = content.find(item => item.type === "text");
  return textContent?.text || "";
};

const ChatEntryMsg = ({ content, isUser, hideContentType = [] }) => {
  return (
    <>
      {content
        .filter(contentItem => !hideContentType.includes(contentItem.type)) // Filter out hidden content types
        .sort((a, b) => a.contentOrder - b.contentOrder)
        .map((contentItem, index) => {
          if (contentItem.type === "text") {
            return (
              <ContentRenders
                key={index}
                content={contentItem.text}
                isUser={isUser}
              />
            );
          } else if (contentItem.type === "image_url") {
            return (
              <div className="m-chat-bubble__image-wrapper" key={index}>
                <img
                  className="m-chat-bubble__image"
                  src={`${contentItem.imageUrl}`}
                  alt={contentItem.imageTextDescription}
                />
              </div>
            );
          } else if (contentItem.type === "image_bytes") {
            // Use the provided mimeType or try to determine from filename, fallback to image/jpeg
            let mimeType = contentItem.mimeType;
            if (!mimeType) {
              // Use original content array (not filtered) to find filename
              const filename = findFilenameInContent(content);
              mimeType = getMimeTypeFromExtension(filename);
            }
            const isSvg = mimeType === "image/svg+xml";
            
            return (
              <div className="m-chat-bubble__image-wrapper" key={index}>
                <img
                  //className={`m-chat-bubble__image ${isSvg ? 'm-chat-bubble__image--svg' : ''}`}
                  //style={isSvg ? { maxWidth: '100%', height: 'auto' } : {}}
                  className="m-chat-bubble__image"
                  src={`data:${mimeType};base64,${contentItem.imageBytes}`}
                  alt={contentItem.imageTextDescription}
                />
              </div>
            );
          } else if (contentItem.type === "html") {
            return (
              <div
                dangerouslySetInnerHTML={{ __html: contentItem.html }}
                key={index}
              />
            );
          } else {
            return <></>;
          }
        })}
    </>
  );
};

export default ChatEntryMsg;